import { useTranslation } from 'react-i18next';
import { ApplicationFlowAttributes } from 'typescript/types/api/capital_shop/application_flows';
import {
  applicationFullName,
  applicationReviewed,
} from 'typescript/utilities/application_flow';
import { fetchLocalizedComponent } from 'typescript/utilities/component_localization';
import { useCheckoutFlow } from 'typescript/context/checkout_flow';

interface FinanceAppProps {
  applicationFlowAttributes?: ApplicationFlowAttributes;
}

const FinanceFields = fetchLocalizedComponent(
  'typescript/apps/checkout_v3/components/payment/pay_in_installments/finance_form/finance_fields/finance_fields',
);

const FinanceApp = ({ applicationFlowAttributes }: FinanceAppProps) => {
  const { t } = useTranslation();
  const { trackingData } = useCheckoutFlow();

  const financeBodyString = applicationReviewed(applicationFlowAttributes)
    ? t('checkout.payment_v3.payInInstallments.financingForm.reviewedBodyNew')
    : t('checkout.payment_v3.payInInstallments.financingForm.pendingBodyNew');

  if (!applicationFlowAttributes) {
    return null;
  }

  return (
    <div className="shop-grid-container">
      <h3 className="shop-grid-item-full">
        {t('checkout.payment_v3.payInInstallments.financingForm.title')}
      </h3>
      <p className="shop-grid-item-full">{financeBodyString}</p>
      {!applicationReviewed(applicationFlowAttributes) && (
        <div className="shop-grid-item-full">
          <FinanceFields
            personalName={applicationFullName(applicationFlowAttributes)}
            personalBirthdate={applicationFlowAttributes.personal_birthdate}
            trackingData={trackingData}
          />
        </div>
      )}
    </div>
  );
};

export default FinanceApp;
